import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { movePets } from '../../actions/pets/pets.actions'
import { getVisitsByFacilityId } from '../../actions/visits/visits.actions'
import SelectPetDropdown from '../../components/Pets/SelectPetDropdown'
import { UnassignedTable } from '../../components/Tables/UnassignedTable'
import { STATUS_ID } from '../../utils'
import Loading from '../common/Loading'

const useStyles = makeStyles((theme) => ({
	root: {
		// flex: 1
	},
	visitsTableContainer: {
		paddingBottom: 60
	},
	bottomBar: {
		position: 'fixed',
		bottom: 0,
		width: '100%',
		height: 60,
		background: '#FFF',
		borderTop: '1px solid #E5E5E5',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 20,
		zIndex: 10000,
		left: 0,
		boxShadow: '0px -3px 10px rgba(0,0,0,0.1)',
		'& i': {
			marginRight: 17,
			cursor: 'pointer',
			color: '#D0CFD2'
		},
		'& .whee': {
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 16,
			color: '#1A1A35'
		},
		'& .checked': {
			color: '#6B4AD6'
		},
		'& .selectedFacility': {
			marginLeft: 10,
			fontSize: 16,
			color: '#6B4AD6 !important',
			textTransform: 'uppercase',
			fontFamily: 'Nunito',
			fontWeight: 'bold'
		},
		[theme.breakpoints.up('md')]: {
			paddingLeft: 261
		}
	}
}))

function useQuery() {
	return new URLSearchParams(useLocation().search)
}

const Unassigned = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const query = useQuery()

	const facility = useSelector((state) => state.specific.facilities.selected)
	const visits = useSelector((state) => state.specific.visits.visits)
	const pets = useSelector((state) => state.specific.visits.pets)

	let originalDate = query.get('date')

	const [date, setDate] = useState(moment(originalDate || moment()).format('YYYY-MM-DD'))
	const [selected, selectPet] = useState([])
	const [filteredPetIds, setFilteredPetIds] = useState([])

	const changeDate = (type) => {
		if (type === 'add') {
			setDate(moment(date).add(1, 'd').format('YYYY-MM-DD'))
		} else if (type === 'subtract') {
			setDate(moment(date).subtract(1, 'd').format('YYYY-MM-DD'))
		}
	}

	useEffect(() => {
		if (facility) {
			dispatch(getVisitsByFacilityId(facility, date))
		}
	}, [date, facility])

	const getUnassigned = () => {
		let pet_ids = []

		visits
			.filter(
				(v) =>
					v.type !== 'grooming' &&
					![STATUS_ID.Cancelled, STATUS_ID['No Show'], STATUS_ID['Completed']].includes(v.status.id)
			)
			.forEach((v, i) => {
				if (v.pet_status && v.status && v.status.id !== 7) {
					v.pet_ids.forEach((id) => {
						let stat = v.pet_status.find((stat) => stat.pet_id == id)
						if (!stat || !stat.playgroup) pet_ids.push(id)
						const petIndex = pets.findIndex((p) => p._id === id)
						if (petIndex > -1) {
							const petCubbies = v.cubbies?.find((cub) => String(cub.pet_id) === String(id)) || null
							pets[petIndex] = { ...pets[petIndex], cubbies: petCubbies }
						}
					})

					// v.pet_status.forEach((stat, i) => {
					// 	if (!stat.playgroup) pet_ids.push(stat.pet_id)
					// })
				}
			})

		let unPets = pet_ids
			.map((id) => {
				return pets.find((p) => p._id === id)
			})
			.filter(Boolean)

		return unPets
	}

	const toggleSelect = () => {
		if (!selected.length) {
			let ids = []
			if (filteredPetIds.length) {
				ids = filteredPetIds
			} else ids = getUnassigned().map((p) => p._id)
			selectPet(ids)
		} else {
			selectPet([])
		}
	}

	const bottomBar = () => {
		// return null;
		let name = ``
		if (!selected.length) {
			name = 'far fa-square'
		} else {
			name = 'fa fa-minus-square checked'
		}
		return (
			<div className={classes.bottomBar}>
				<i className={name} style={{ fontSize: 16 }} onClick={() => toggleSelect()} />
				<span className="whee">
					{selected.length} {`Pet${selected.length === 0 || selected.length > 1 ? 's' : ''}`} Selected
				</span>
				<SelectPetDropdown
					playgroups={facility.playgroups.filter((p) => p.status === 'in use')}
					selectGroup={selectGroup}
					selected={selected}
					visits={
						visits ? visits.filter((v) => v.status && v.status.id !== 7 && v.type !== 'grooming') : []
					}
				/>
			</div>
		)
	}

	const selectGroup = (group) => {
		if (group) {
			let ourVisits = []
			visits.forEach((v) => {
				if (v.pet_ids) {
					v.pet_ids.forEach((id, i) => {
						if (selected.includes(id)) ourVisits.push(v._id)
					})
				}
			})

			let payload = {
				pet_ids: selected,
				playgroup: group._id,
				visit_ids: ourVisits
			}

			dispatch(movePets(payload))
			selectPet([])
		}
	}

	return (
		<div className={classes.root}>
			{facility ? (
				<div className={classes.visitsTableContainer}>
					<UnassignedTable
						unassigned_pets={visits ? getUnassigned() : []}
						pets={pets}
						date={date}
						changeDate={changeDate}
						setDate={setDate}
						selected={selected}
						selectPet={selectPet}
						visits={
							visits?.filter((v) => v.status && v.status.id !== 7 && v.type !== 'grooming') || []
						}
						setFilteredPetIds={setFilteredPetIds}
					/>
					{bottomBar()}
				</div>
			) : (
				<Loading />
			)}
		</div>
	)
}

export default Unassigned
